import {
	Checkbox,
	FormItem,
	ValidationError
} from "client/Components";
import { IValueInputAttachable } from "client/Forms/attachable";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { UsersAndUserGroupsDataModel } from "client/Api/UserGroupsManagement/userGroupsManagement";
import {
	UserAndUserGroupCollection,
	UserAndUserGroupKind
} from "client/Features/Users/UserAndUserGroupCollection/UserAndUserGroupCollection";
import { ActiveTab } from "client/Features/Users/UserAndUserGroupTabSelector/UserAndUserGroupTabSelector";
import { attachToUserAndUserGroupCollection } from "client/Features/Users/UserAndUserGroupCollection/attachable";
import { PermissionsUnionModel } from "client/Api/common";
import styles from "./WhoHasAccess.module.less";

export type WhoHasAccessProps = {
	attachable: IValueInputAttachable<PermissionsUnionModel>;
	usersAndUserGroupsData: UsersAndUserGroupsDataModel;
};

export const WhoHasAccess = (props: WhoHasAccessProps): ReactElement => {
	const {
		attachable,
		usersAndUserGroupsData
	} = props;

	return (
		<div className={styles.root}>
			<FormItem>
				<Checkbox
					{...attachable.for("everyone").attachToCheckbox()}
					text={localize("_EveryoneHasAccess")}
				/>
				<ValidationError {...attachable.for("everyone").attachToValidationError()} />
			</FormItem>
			{attachable.when(
				x => !x.everyone,
				(permissonsHandler) => (
					<>
						<UserAndUserGroupCollection
							{...attachToUserAndUserGroupCollection(
								permissonsHandler.for("specificSet"),
								{
									kind: UserAndUserGroupKind.Edit,
									dialogTitleWhenAddingUsersAndUserGroups: localize("_AddGroupsOrUsers")
								}
							)}
							activeTab={ActiveTab.UserGroup}
							allUsersAndUserGroupsData={usersAndUserGroupsData}
						/>
						<ValidationError {...permissonsHandler.for("specificSet").attachToValidationError()} />
					</>
				)
			)}
		</div>
	);
};
WhoHasAccess.displayName = "WhoHasAccess";
